import { render, staticRenderFns } from "./nakladnayaPeredacha.vue?vue&type=template&id=8a569e68&scoped=true"
import script from "./nakladnayaPeredacha.vue?vue&type=script&lang=js"
export * from "./nakladnayaPeredacha.vue?vue&type=script&lang=js"
import style0 from "./nakladnayaPeredacha.vue?vue&type=style&index=0&id=8a569e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a569e68",
  null
  
)

export default component.exports